import axiosClient from "../../axios";

export async function createOperator({ commit }, operator) {
    return await axiosClient.post('/admin/operators', operator)
}

export async function getOperators({ commit, state }, { url = null, search = '', status, per_page, sort_field, sort_direction } = {}) {
    commit('setOperators', [true])
    url = url || "/admin/operators"
    const params = {
        per_page: state.operators.limit,
    }

    return await axiosClient.get(url, {
        params: {
            ...params,
            search, status, per_page, sort_field, sort_direction
        }
    })
        .then((response) => {
            commit('setOperators', [false, response.data])
        })
        .catch(() => {
            commit('setOperators', [false])
        })
}

export async function updateOperator({ commit }, operator) {
    return await axiosClient.put(`/admin/operators/${operator.id}`, operator);
}

export async function changePasswordOperator({ commit }, operator) {
    return await axiosClient.put(`/admin/operators/change-password/${operator.id}`, operator);
}

export async function createCategory({ commit }, category) {

    const form = new FormData();
    form.append('parent_id', category.parent_id ? category.parent_id : '');
    form.append('category_name', category.category_name || '');
    form.append('category_slug', category.category_slug || '');
    form.append('is_in_menu', parseInt(category.is_in_menu) ? 1 : 0);

    if (category.category_image instanceof File) {
        form.append('category_image', category.category_image);
    } else {
        form.append('category_image', '');
    }

    category = form;
    return await axiosClient.post('/admin/categories', category)
}

export async function getCategoriesWithAttributes({ commit }) {
    commit('setCategoriesWithAttributes', [true])

    return await axiosClient.get("/admin/categories/with-attributes")
        .then((response) => {
            commit('setCategoriesWithAttributes', [false, response.data])
        })
        .catch(() => {
            commit('setCategoriesWithAttributes', [false])
        })
}

export async function getCategoriesWithProducts({ commit }) {
    commit('setCategoriesWithProducts', [true])

    return await axiosClient.get("/admin/categories/with-products")
        .then((response) => {
            commit('setCategoriesWithProducts', [false, response.data])
        })
        .catch(() => {
            commit('setCategoriesWithProducts', [false])
        })
}

export async function getCategories({ commit, state }, { url = null, search = '', is_in_menu, per_page, sort_field, sort_direction } = {}) {
    commit('setCategories', [true])
    url = url || "/admin/categories"
    const params = {
        per_page: state.categories.limit,
    }

    return await axiosClient.get(url, {
        params: {
            ...params,
            search, is_in_menu, per_page, sort_field, sort_direction
        }
    })
        .then((response) => {
            commit('setCategories', [false, response.data])
        })
        .catch(() => {
            commit('setCategories', [false])
        })
}

export async function getCategory({ commit }, id) {
    return await axiosClient.get(`/admin/categories/${id}`)
}

export function updateCategory({ commit }, category) {

    const id = category.id
    const form = new FormData();
    form.append('id', category.id);
    form.append('parent_id', category.parent_id ? category.parent_id : '');
    form.append('category_name', category.category_name || '');
    form.append('category_slug', category.category_slug || '');
    form.append('is_in_menu', parseInt(category.is_in_menu) ? 1 : 0);

    if (category.category_image instanceof File) {
        form.append('category_image', category.category_image);
    } else {
        form.append('category_image', '');
    }

    form.append('_method', 'PUT');
    category = form;

    return axiosClient.post(`/admin/categories/${id}`, category)
}

export async function createAttribute({ commit }, attribute) {
    return await axiosClient.post('/admin/attributes', attribute)
}

export async function getAttributes({ commit, state }, { url = null, search = '', categoryId = '', per_page, sort_field, sort_direction, paginate = true } = {}) {

    commit('setAttributes', [true])
    url = url || "/admin/attributes"
    const params = {
        per_page: state.attributes.limit,
    }

    return await axiosClient.get(url, {
        params: {
            ...params,
            search, categoryId, per_page, sort_field, sort_direction
        }
    })
        .then((response) => {
            commit('setAttributes', [false, response.data])
        })
        .catch(() => {
            commit('setAttributes', [false])
        })
}

export async function getAttributesNoPagination({ commit }) {
    commit('setAttributesNoPagination', [true])

    return await axiosClient.get("/admin/attributes/no-pagination")
        .then((response) => {

            commit('setAttributesNoPagination', [false, response.data])
        })
        .catch(() => {
            commit('setAttributesNoPagination', [false])
        })
}

export async function getAllAttributes({ commit }) {
    commit('setAllAttributes', [true])

    return await axiosClient.get("/admin/attributes/all")
        .then((response) => {

            commit('setAllAttributes', [false, response.data])
        })
        .catch(() => {
            commit('setAllAttributes', [false])
        })
}

export async function getAttribute({ commit }, id) {
    return await axiosClient.get(`/admin/attributes/${id}`)
}


export async function updateAttribute({ commit }, attribute) {
    return await axiosClient.put(`/admin/attributes/${attribute.id}`, attribute);
}

export async function createValue({ commit }, value) {
    return await axiosClient.post('/admin/values', value)
}

export async function getValues({ commit, state }, { url = null, search = '', attributeId = '', per_page, sort_field, sort_direction } = {}) {
    commit('setValues', [true])
    url = url || "/admin/values"
    const params = {
        per_page: state.values.limit,
    }

    return await axiosClient.get(url, {
        params: {
            ...params,
            search, attributeId, per_page, sort_field, sort_direction
        }
    })
        .then((response) => {
            commit('setValues', [false, response.data])
        })
        .catch(() => {
            commit('setValues', [false])
        })
}

export async function getValue({ commit }, id) {
    return await axiosClient.get(`/admin/values/${id}`)
}

export async function getAttributeValues({ commit }, attributeId) {
    commit('setAttributeValues', [true])

    return await axiosClient.get(`/admin/attributes/${attributeId}/values`)
        .then((response) => {
            commit('setAttributeValues', [false, response.data])
        })
        .catch(() => {
            commit('setAttributeValues', [false])
        })
}

export async function updateValue({ commit }, value) {
    return await axiosClient.put(`/admin/values/${value.id}`, value);
}

export async function createProduct({ commit }, { product, value_id, tag_id, product_gallery }) {

    const form = new FormData();
    form.append('category_id', product.selectedCategory);
    form.append('product_name', product.product_name);
    form.append('product_price', product.product_price);
    form.append('product_inventory', product.product_inventory);
    form.append('discount_percent', product.discount_percent);
    form.append('discount_price', product.discount_price);
    form.append('long_description', product.long_description);
    form.append('meta_title', product.meta_title);
    form.append('meta_keywords', product.meta_keywords);
    form.append('meta_description', product.meta_description);
    form.append('featured', product.featured ? 1 : 0);
    form.append('special_sale', product.special_sale ? 1 : 0);
    form.append('incredible_offer', product.incredible_offer ? 1 : 0);
    form.append('incredible_offer_discount_percent', product.incredible_offer_discount_percent);
    form.append('incredible_offer_discount_price', product.incredible_offer_discount_price);
    form.append('incredible_offer_hour', product.incredible_offer_hour);
    form.append('product_image', product.product_image);
    form.append('status', parseInt(product.status) ? 1 : 0);

    for (let j = 0; j < value_id.length; j++) {
        form.append('valueId[]', value_id[j])
    }

    for (let j = 0; j < tag_id.length; j++) {
        form.append('tagId[]', tag_id[j])
    }

    for (let i = 0; i < product_gallery.length; i++) {
        form.append('productGallery[]', product_gallery[i]);
    }

    /* if (form.has('file[]')) {
        let filesArray = form.getAll('file[]');
        console.log(filesArray);
      } else {
        console.log("فیلد file[] وجود ندارد")
      } */

    product = form;

    return await axiosClient.post('/products', product)
}

export async function getProducts({ commit, state }, { url = null, search = '', categoryId = '', createdBy = '', status, per_page, sort_field, sort_direction } = {}) {
    commit('setProducts', [true])
    url = url || "/products"
    const params = {
        per_page: state.products.limit,
    }

    return await axiosClient.get(url, {
        params: {
            ...params,
            search, categoryId, createdBy, status, per_page, sort_field, sort_direction
        }
    })
        .then((response) => {
            commit('setProducts', [false, response.data])
        })
        .catch(() => {
            commit('setProducts', [false])
        })
}

export async function getCreatorsWithProducts({ commit }) {
    commit('setCreatorsWithProducts', [true])

    return await axiosClient.get("/admin/products/creators")
        .then((response) => {
            commit('setCreatorsWithProducts', [false, response.data])
        })
        .catch(() => {
            commit('setCreatorsWithProducts', [false])
        })
}


export function updateProduct({ commit }, { product, value_id, tag_id, product_gallery }) {

    const id = product.value.id
    const form = new FormData();

    form.append('id', product.id);
    form.append('category_id', product.value.category_id);
    form.append('product_name', product.value.product_name);
    form.append('product_price', product.value.product_price);
    form.append('product_inventory', product.value.product_inventory);
    form.append('discount_percent', product.value.discount_percent || '');
    form.append('discount_price', product.value.discount_price || '');
    form.append('long_description', product.value.long_description || '');
    form.append('meta_title', product.value.meta_title || '');
    form.append('meta_keywords', product.value.meta_keywords || '');
    form.append('meta_description', product.value.meta_description || '');
    form.append('featured', product.value.featured ? 1 : 0);
    form.append('special_sale', product.value.special_sale ? 1 : 0);
    form.append('incredible_offer', product.value.incredible_offer ? 1 : 0);
    form.append('incredible_offer_discount_percent', product.value.incredible_offer_discount_percent || '');
    form.append('incredible_offer_discount_price', product.value.incredible_offer_discount_price || '');
    form.append('incredible_offer_hour', product.value.incredible_offer_hour || '');
    form.append('status', parseInt(product.value.status) ? 1 : 0);

    for (let j = 0; j < value_id.length; j++) {
        form.append('valueId[]', value_id[j])
    }

    for (let j = 0; j < tag_id.length; j++) {
        form.append('tagId[]', tag_id[j])
    }

    if (product_gallery.length > 0) {
        for (let i = 0; i < product_gallery.length; i++) {
            form.append('productGallery[]', product_gallery[i]);
        }
    }


    if (product.value.product_image instanceof File) {
        form.append('product_image', product.value.product_image);
    } else {
        form.append('product_image', '');
    }

    form.append('_method', 'PUT');
    product = form;

    return axiosClient.post(`/products/${id}`, product)
}

export async function createUser({ commit }, user) {
    return await axiosClient.post('/admin/users', user)
}

export async function getUsers({ commit, state }, { url = null, search = '', status, created_at, per_page, sort_field, sort_direction } = {}) {
    commit('setUsers', [true])
    url = url || "/admin/users"
    const params = {
        per_page: state.users.limit,
    }

    return await axiosClient.get(url, {
        params: {
            ...params,
            search, status, created_at, per_page, sort_field, sort_direction
        }
    })
        .then((response) => {
            commit('setUsers', [false, response.data])
        })
        .catch(() => {
            commit('setUsers', [false])
        })
}

export async function getUser({ commit }, id) {
    return await axiosClient.get(`/admin/users/${id}`)
}

export async function updateUser({ commit }, user) {
    return await axiosClient.put(`/admin/users/${user.id}`, user);
}

export async function createSlider({ commit }, slider) {

    const form = new FormData();
    form.append('slider_image', slider.slider_image);
    form.append('slider_title', slider.slider_title || '');
    form.append('slider_link', slider.slider_link || '');
    form.append('slider_priority', slider.slider_priority || '');
    form.append('status', parseInt(slider.status) ? 1 : 0);
    slider = form;
    return await axiosClient.post('/admin/sliders', slider)
}

export async function getSliders({ commit, state }, { url = null, search = '', status, per_page, sort_field, sort_direction } = {}) {
    commit('setSliders', [true])
    url = url || "/admin/sliders"
    const params = {
        per_page: state.sliders.limit,
    }

    return await axiosClient.get(url, {
        params: {
            ...params,
            search, status, per_page, sort_field, sort_direction
        }
    })
        .then((response) => {
            commit('setSliders', [false, response.data])
        })
        .catch(() => {
            commit('setSliders', [false])
        })
}

export async function getSlider({ commit }, id) {
    return await axiosClient.get(`/admin/sliders/${id}`)
}

export function updateSlider({ commit }, slider) {

    const id = slider.id
    const form = new FormData();
    form.append('id', slider.id);
    form.append('slider_title', slider.slider_title || '');
    form.append('slider_link', slider.slider_link || '');
    form.append('slider_priority', slider.slider_priority || '');
    form.append('status', parseInt(slider.status) ? 1 : 0);

    if (slider.slider_image instanceof File) {
        form.append('slider_image', slider.slider_image);
    } else {
        form.append('slider_image', '');
    }

    form.append('_method', 'PUT');
    slider = form;

    return axiosClient.post(`/admin/sliders/${id}`, slider)
}

export function deleteSlider({ commit }, slider) {
    return axiosClient.delete(`/admin/sliders/${slider.id}`)
}

export async function createStore({ commit }, store) {
    return await axiosClient.post('/admin/stores', store)
}

export async function getStores({ commit, state }, { url = null, search = '', status, per_page, sort_field, sort_direction } = {}) {
    commit('setStores', [true])
    url = url || "/admin/stores"
    const params = {
        per_page: state.stores.limit,
    }

    return await axiosClient.get(url, {
        params: {
            ...params,
            search, status, per_page, sort_field, sort_direction
        }
    })
        .then((response) => {
            commit('setStores', [false, response.data])
        })
        .catch(() => {
            commit('setStores', [false])
        })
}

export async function getStore({ commit }, id) {
    return await axiosClient.get(`/admin/stores/${id}`)
}

export async function updateStore({ commit }, store) {
    return await axiosClient.put(`/admin/stores/${store.id}`, store);
}

export async function getOrderItemsByStore({ commit }, storeId) {
    return await axiosClient.get(`/admin/store/${storeId}/order-items`)
}

export async function getSettings({ commit }, id) {
    return await axiosClient.get(`/admin/settings/${id}`)
}

export function updateSettings({ commit }, { settings }) {

    const id = 1;
    const form = new FormData();

    form.append('application_name', settings.value.application_name);
    form.append('referral_code_recharge', settings.value.referral_code_recharge || '');
    form.append('shipping_cost', settings.value.shipping_cost);
    form.append('minimum_order_amount', settings.value.minimum_order_amount);
    form.append('maximum_order_amount', settings.value.maximum_order_amount);
    form.append('tax_percentage', settings.value.tax_percentage);
    form.append('support_phone_number', settings.value.support_phone_number);
    form.append('app_version', settings.value.app_version);
    form.append('about_us', settings.value.about_us || '');
    form.append('contact_us', settings.value.contact_us || '');
    form.append('terms_conditions', settings.value.terms_conditions || '');
    form.append('update_text', settings.value.update_text || '');

    if (settings.value.application_logo instanceof File) {
        form.append('application_logo', settings.value.application_logo);
    } else {
        form.append('application_logo', '');
    }


    form.append('_method', 'PUT');
    settings = form;

    return axiosClient.post(`/admin/settings/${id}`, settings)
}

export async function getOrders({ commit, state }, { url = null, search = '', status, per_page, sort_field, sort_direction } = {}) {
    commit('setOrders', [true])
    url = url || "/admin/orders"
    const params = {
        per_page: state.orders.limit,
    }

    return await axiosClient.get(url, {
        params: {
            ...params,
            search, status, per_page, sort_field, sort_direction
        }
    })
        .then((response) => {
            commit('setOrders', [false, response.data])
        })
        .catch(() => {
            commit('setOrders', [false])
        })
}

export async function getOrder({ commit }, id) {
    return await axiosClient.get(`/admin/orders/${id}`)
}

export async function updateOrder({ commit }, order) {
    return await axiosClient.put(`/admin/orders/${order.id}`, order);
}

export async function getTransactions({ commit, state }, { url = null, search = '', status, per_page, sort_field, sort_direction } = {}) {
    commit('setTransactions', [true])
    url = url || "/admin/transactions"
    const params = {
        per_page: state.transactions.limit,
    }

    return await axiosClient.get(url, {
        params: {
            ...params,
            search, status, per_page, sort_field, sort_direction
        }
    })
        .then((response) => {
            commit('setTransactions', [false, response.data])
        })
        .catch(() => {
            commit('setTransactions', [false])
        })
}

export async function getUserWallet({ commit }, userId) {
    return await axiosClient.get(`/admin/wallet-amount/${userId}`)
}

export async function updateWallet({ commit }, walletData) {
    return await axiosClient.post('/admin/update-wallet', walletData)
}

export async function getWalletTransactions({ commit, state }, { url = null, userId, transactionType, actionType, created_at, per_page, sort_field, sort_direction } = {}) {
    commit('setWalletTransactions', [true])
    url = url || "/admin/wallet-transactions"
    const params = {
        per_page: state.walletTransactions.limit,
    }

    return await axiosClient.get(url, {
        params: {
            ...params,
            userId, transactionType, actionType, created_at, per_page, sort_field, sort_direction
        }
    })
        .then((response) => {
            commit('setWalletTransactions', [false, response.data])
        })
        .catch(() => {
            commit('setWalletTransactions', [false])
        })
}

export async function getUserMessages({ commit }, userId) {
    return await axiosClient.get(`/admin/user-messages/${userId}`)
}

export async function replyToMessage(_, formData) {
    return await axiosClient.post('/admin/reply-message', formData)
}

export async function createBanner({ commit }, banner) {
    const form = new FormData();
    form.append('ads_image', banner.ads_image);
    form.append('ads_title', banner.ads_title || '');
    form.append('ads_link', banner.ads_link || '');
    form.append('status', parseInt(banner.status) ? 1 : 0);
    banner = form;
    return await axiosClient.post('/admin/ads', banner)
}

export async function getBanners({ commit, state }, { url = null, search = '', status, per_page, sort_field, sort_direction } = {}) {
    commit('setBanners', [true])
    url = url || "/admin/ads"
    const params = {
        per_page: state.banners.limit,
    }

    return await axiosClient.get(url, {
        params: {
            ...params,
            search, status, per_page, sort_field, sort_direction
        }
    })
        .then((response) => {
            commit('setBanners', [false, response.data])
        })
        .catch(() => {
            commit('setBanners', [false])
        })
}

export async function getBanner({ commit }, id) {
    return await axiosClient.get(`/admin/ads/${id}`)
}

export function updateBanner({ commit }, banner) {

    const id = banner.id
    const form = new FormData();
    form.append('id', banner.id);
    form.append('ads_title', banner.ads_title || '');
    form.append('ads_link', banner.ads_link || '');
    form.append('status', parseInt(banner.status) ? 1 : 0);

    if (banner.ads_image instanceof File) {
        form.append('ads_image', banner.ads_image);
    } else {
        form.append('ads_image', '');
    }

    form.append('_method', 'PUT');
    banner = form;

    return axiosClient.post(`/admin/ads/${id}`, banner)
}

export function deleteBanner({ commit }, banner) {
    return axiosClient.delete(`/admin/ads/${banner.id}`)
}

export async function getComments({ commit, state }, { url = null, search = '', status, per_page, sort_field, sort_direction } = {}) {
    commit('setComments', [true])
    url = url || "/admin/comments"
    const params = {
        per_page: state.comments.limit,
    }

    return await axiosClient.get(url, {
        params: {
            ...params,
            search, status, per_page, sort_field, sort_direction
        }
    })
        .then((response) => {
            commit('setComments', [false, response.data])
        })
        .catch(() => {
            commit('setComments', [false])
        })
}

export async function getComment({ commit }, id) {
    return await axiosClient.get(`/admin/comments/${id}`)
}

export async function updateComment({ commit }, comment) {
    return await axiosClient.put(`/admin/comments/${comment.id}`, comment);
}

export async function getFaqs({ commit, state }, { url = null, search = '', status, per_page, sort_field, sort_direction } = {}) {
    commit('setFaqs', [true])
    url = url || "/admin/product-faqs"
    const params = {
        per_page: state.faqs.limit,
    }

    return await axiosClient.get(url, {
        params: {
            ...params,
            search, status, per_page, sort_field, sort_direction
        }
    })
        .then((response) => {
            commit('setFaqs', [false, response.data])
        })
        .catch(() => {
            commit('setFaqs', [false])
        })
}

export async function getFaq({ commit }, id) {
    return await axiosClient.get(`/admin/product-faqs/${id}`)
}

export async function updateFaq({ commit }, faq) {
    return await axiosClient.put(`/admin/product-faqs/${faq.id}`, faq);
}

export function deleteFaq({ commit }, faq) {
    return axiosClient.delete(`/admin/product-faqs/${faq.id}`)
}

export async function getMessages({ commit, state }, { url = null, search = '', unread_messages, per_page, sort_field, sort_direction } = {}) {
    commit('setMessages', [true])
    url = url || "/admin/users-messages"
    const params = {
        per_page: state.messages.limit,
    }

    return await axiosClient.get(url, {
        params: {
            ...params,
            search, unread_messages, per_page, sort_field, sort_direction
        }
    })
        .then((response) => {
            commit('setMessages', [false, response.data])
        })
        .catch(() => {
            commit('setMessages', [false])
        })
}

export async function getFaqCount({ commit }) {
    return await axiosClient.get('/admin/product-faqs/count')
}

export async function getCommentCount({ commit }) {
    return await axiosClient.get('/admin/comments/count')
}

export async function getMessageCount({ commit }) {
    return await axiosClient.get('/admin/messages/count')
}

export async function getOrderCount({ commit }) {
    return await axiosClient.get('/admin/orders/count')
}

export async function getAllOccasionTypes({ commit }) {
    commit('setAllOccasionTypes', [true])

    return await axiosClient.get("/admin/occasions/types/all")
        .then((response) => {
            commit('setAllOccasionTypes', [false, response.data])
        })
        .catch(() => {
            commit('setAllOccasionTypes', [false])
        })
}

export async function createOccasion({ commit }, { occasion }) {

    const form = new FormData();
    form.append('tag_id', occasion.selectedTag || '');
    form.append('occasion_type_id', occasion.selectedOccasionType);

    form.append('title', occasion.title);
    form.append('description', occasion.description);
    form.append('full_description', occasion.full_description);
    form.append('buy_text', occasion.buy_text || '');
    form.append('occasion_date', occasion.occasion_date);
    form.append('occasion_date_type', occasion.occasion_date_type ? occasion.occasion_date_type : 0);

    form.append('occasion_image', occasion.occasion_image);

    form.append('reminder_text_1', occasion.reminder_text_1);
    form.append('reminder_text_2', occasion.reminder_text_2);
    form.append('reminder_text_3', occasion.reminder_text_3);
    form.append('reminder_text_4', occasion.reminder_text_4);
    form.append('reminder_text_5', occasion.reminder_text_5);
    form.append('reminder_text_6', occasion.reminder_text_6);

    form.append('is_public', parseInt(occasion.is_public) ? 1 : 0);


    occasion = form;

    return await axiosClient.post('/admin/occasions', occasion)
}

export async function getOccasionTypesWithOccasions({ commit }) {
    commit('setOccasionTypesWithOccasions', [true])

    return await axiosClient.get("/admin/occasions/types/with-occasion")
        .then((response) => {
            commit('setOccasionTypesWithOccasions', [false, response.data])
        })
        .catch(() => {
            commit('setOccasionTypesWithOccasions', [false])
        })
}

export async function getOccasions({ commit, state }, { url = null, search = '', occasionTypeId = '', occasionDateType = '', is_public, per_page, sort_field, sort_direction } = {}) {

    commit('setOccasions', [true])
    url = url ? `/admin/occasions?page=${url}` : "/admin/occasions"
    const params = {
        per_page: state.occasions.limit,
    }

    return await axiosClient.get(url, {
        params: {
            ...params,
            search, occasionTypeId, occasionDateType, is_public, per_page, sort_field, sort_direction
        }
    })
        .then((response) => {
            commit('setOccasions', [false, response.data])
        })
        .catch(() => {
            commit('setOccasions', [false])
        })
}

export async function getOccasion({ commit }, id) {
    return await axiosClient.get(`/admin/occasions/${id}`)
}

export function updateOccasion({ commit }, { occasion }) {

    const id = occasion.value.id
    const form = new FormData();

    form.append('id', occasion.id);

    form.append('tag_id', occasion.value.tag_id || '');
    form.append('occasion_type_id', occasion.value.occasion_type_id || '');

    form.append('title', occasion.value.title);
    form.append('description', occasion.value.description || '');
    form.append('full_description', occasion.value.full_description || '');
    form.append('buy_text', occasion.value.buy_text || '');
    form.append('occasion_date', occasion.value.occasion_date || '');
    form.append('occasion_date_type', occasion.value.occasion_date_type ? occasion.value.occasion_date_type : 0);

    form.append('reminder_text_1', occasion.value.reminder_text_1 || '');
    form.append('reminder_text_2', occasion.value.reminder_text_2 || '');
    form.append('reminder_text_3', occasion.value.reminder_text_3 || '');
    form.append('reminder_text_4', occasion.value.reminder_text_4 || '');
    form.append('reminder_text_5', occasion.value.reminder_text_5 || '');
    form.append('reminder_text_6', occasion.value.reminder_text_6 || '');

    form.append('is_public', parseInt(occasion.value.is_public) ? 1 : 0);



    if (occasion.value.occasion_image instanceof File) {
        form.append('occasion_image', occasion.value.occasion_image);
    } else {
        form.append('occasion_image', '');
    }

    form.append('_method', 'PUT');
    occasion = form;

    return axiosClient.post(`/admin/occasions/${id}`, occasion)
}


export async function storeSettlement({ commit }, data) {
    return await axiosClient.post('/admin/store/settlement', data)
}

export async function getAllStoreSales({ commit, state }, { url = null, storeId, search = '', order_status, per_page, sort_field, sort_direction } = {}) {
    commit('setAllStoreSales', [true])
    url = url || `/admin/store/${storeId}/all-sales`
    const params = {
        per_page: state.allStoreSales.limit,
    }

    return await axiosClient.get(url, {
        params: {
            ...params,
            search, order_status, per_page, sort_field, sort_direction
        }
    })
        .then((response) => {
            commit('setAllStoreSales', [false, response.data])
            return response
        })
        .catch(() => {
            commit('setAllStoreSales', [false])
        })
}

export async function createTag({ commit }, tag) {

    const form = new FormData();
    form.append('tag_image', tag.tag_image);
    form.append('tag_name', tag.tag_name || '');
    form.append('tag_priority', tag.tag_priority || '');

    tag = form;
    return await axiosClient.post('/admin/tags', tag)
}

export async function getTags({ commit, state }, { url = null, search = '', status, per_page, sort_field, sort_direction } = {}) {
    commit('setTags', [true])
    url = url || "/admin/tags"
    const params = {
        per_page: state.tags.limit,
    }

    return await axiosClient.get(url, {
        params: {
            ...params,
            search, status, per_page, sort_field, sort_direction
        }
    })
        .then((response) => {
            commit('setTags', [false, response.data])
        })
        .catch(() => {
            commit('setTags', [false])
        })
}

export async function getTag({ commit }, id) {
    return await axiosClient.get(`/admin/tags/${id}`)
}

export function updateTag({ commit }, tag) {

    const id = tag.id
    const form = new FormData();
    form.append('id', tag.id);
    form.append('tag_name', tag.tag_name || '');
    form.append('tag_priority', tag.tag_priority || '');

    if (tag.tag_image instanceof File) {
        form.append('tag_image', tag.tag_image);
    } else {
        form.append('tag_image', '');
    }

    form.append('_method', 'PUT');
    tag = form;

    return axiosClient.post(`/admin/tags/${id}`, tag)
}

export async function getCooperationRequests({ commit, state }, { url = null, search = '', per_page, sort_field, sort_direction } = {}) {
    commit('setCooperationRequests', [true])
    url = url || "/admin/sales-collaborator"
    const params = {
        per_page: state.cooperationRequests.limit,
    }

    return await axiosClient.get(url, {
        params: {
            ...params,
            search, per_page, sort_field, sort_direction
        }
    })
        .then((response) => {
            commit('setCooperationRequests', [false, response.data])
        })
        .catch(() => {
            commit('setCooperationRequests', [false])
        })
}

export async function getAllStoreSettlements({ commit, state }, { url = null, storeId, per_page, sort_field, sort_direction } = {}) {
    commit('setAllStoreSettlements', [true])
    url = url || `/admin/store/${storeId}/all-settlements`
    const params = {
        per_page: state.allStoreSales.limit,
    }

    return await axiosClient.get(url, {
        params: {
            ...params,
            per_page, sort_field, sort_direction
        }
    })
        .then((response) => {
            commit('setAllStoreSettlements', [false, response.data])
            return response
        })
        .catch(() => {
            commit('setAllStoreSettlements', [false])
        })
}

export async function getOrderStats({ commit }) {
    return await axiosClient.get('/admin/order-stats')
}

export async function getTodayPendingOrder({ commit }) {
    return await axiosClient.get('/admin/today-pending-orders-stats')
}

export async function getTotalUsers({ commit }) {
    return await axiosClient.get('/admin/total-users')
}

export async function getTodayRegisteredUsers({ commit }) {
    return await axiosClient.get('/admin/today-registered-users')
}

export async function getSettlementStats({ commit }) {
    return await axiosClient.get('/admin/settlement-stats')
}

export async function getBestSellingProducts({ commit }) {
    commit('setBestSellingProducts', [true])

    return await axiosClient.get('/admin/best-selling-products')
        .then((response) => {
            commit('setBestSellingProducts', [false, response.data])
        })
        .catch(() => {
            commit('setBestSellingProducts', [false])
        })
}

export async function getTopSellingStores({ commit }) {
    commit('setTopSellingStores', [true])

    return await axiosClient.get('/admin/top-selling-stores')
        .then((response) => {
            commit('setTopSellingStores', [false, response.data])
        })
        .catch(() => {
            commit('setTopSellingStores', [false])
        })
}

export async function getLastPendingOrders({ commit }) {
    commit('setLastPendingOrders', [true])

    return await axiosClient.get('/admin/last-pending-orders')
        .then((response) => {
            commit('setLastPendingOrders', [false, response.data])
        })
        .catch(() => {
            commit('setLastPendingOrders', [false])
        })
}
